"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
require("core-js/modules/es.object.values.js");
var _react = _interopRequireDefault(require("react"));
var _ACQ = _interopRequireWildcard(require("./ACQ5"));
var _address = _interopRequireWildcard(require("./address"));
var _age = _interopRequireWildcard(require("./age"));
var _checkbox = _interopRequireWildcard(require("./checkbox"));
var _checkbox2 = _interopRequireWildcard(require("./checkbox2"));
var _color = _interopRequireWildcard(require("./color"));
var _date = _interopRequireDefault(require("./date"));
var _validations = require("./date/validations");
var _datetime = _interopRequireWildcard(require("./datetime"));
var _dob = _interopRequireWildcard(require("./dob"));
var _emailConfirm = _interopRequireDefault(require("./emailConfirm"));
var _english = _interopRequireWildcard(require("./english"));
var _language_intl = _interopRequireWildcard(require("./language_intl"));
var _ethnicity = _interopRequireWildcard(require("./ethnicity"));
var _ESS = _interopRequireWildcard(require("./ESS"));
var _fieldContainer = _interopRequireDefault(require("./fieldContainer"));
var _fileUpload = _interopRequireWildcard(require("./fileUpload"));
var _GAD = _interopRequireWildcard(require("./GAD7"));
var _gender = _interopRequireWildcard(require("./gender"));
var _maskCustom = _interopRequireWildcard(require("./maskCustom"));
var _number = require("./number");
var _PHQ = _interopRequireWildcard(require("./PHQ9"));
var _pregnancy = _interopRequireWildcard(require("./pregnancy"));
var _rangeHorizontal = _interopRequireDefault(require("./rangeHorizontal"));
var _rangeSlider = _interopRequireDefault(require("./rangeSlider"));
var _validations2 = require("./rangeSlider/validations");
var _selectNumberRange = _interopRequireDefault(require("./selectNumberRange"));
var _time = _interopRequireDefault(require("./time"));
var _selectAdvanced = _interopRequireDefault(require("./selectAdvanced"));
var _sex = _interopRequireWildcard(require("./sex"));
var _radio = _interopRequireDefault(require("./radio"));
var _radio2 = _interopRequireDefault(require("./radio2"));
var _usResident = _interopRequireWildcard(require("./usResident"));
var _country_resident = _interopRequireWildcard(require("./country_resident"));
var _pin = _interopRequireWildcard(require("./pin"));
var _simpleMatrix = _interopRequireWildcard(require("./simpleMatrix"));
var _typingTest = _interopRequireDefault(require("./typingTest"));
var _textAreaFile = _interopRequireWildcard(require("./textAreaFile"));
var _codeArea = _interopRequireDefault(require("./codeArea"));
var _heightIntl = _interopRequireWildcard(require("./heightIntl"));
var _phonenumberIntl = _interopRequireDefault(require("./phonenumberIntl"));
var _weightIntl = _interopRequireWildcard(require("./weightIntl"));
var _passwordModern = _interopRequireWildcard(require("./passwordModern"));
var _aside = _interopRequireDefault(require("./aside"));
var _error_summary = _interopRequireDefault(require("./error_summary"));
var _excluded = ["input"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * @desc Takes answer object and converts values to an array.
 *
 * @type {({[key: string]: string}) => string[]}
 */
var retrieveAnswers = function retrieveAnswers(answers) {
  return Object.values(answers);
};
var _default = exports["default"] = {
  acq5: {
    component: _ACQ["default"],
    validations: _ACQ.validations
  },
  address: {
    component: _address["default"],
    validations: _address.validations
  },
  age: {
    component: _age["default"],
    answers: _age.answers
  },
  aside: {
    component: _aside["default"]
  },
  checkbox: {
    component: _checkbox["default"],
    validations: _checkbox.validations
  },
  checkbox2: {
    component: _checkbox2["default"],
    validations: _checkbox2.validations
  },
  checkboxgroupwithnone: {
    component: _checkbox["default"],
    validations: _checkbox.validations
  },
  color: {
    component: _color["default"],
    validations: _color.validations
  },
  date_picker: {
    component: function component(_ref) {
      var input = _ref.input,
        rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
      return /*#__PURE__*/_react["default"].createElement(_date["default"], (0, _extends2["default"])({}, rest, input));
    },
    validations: _validations.validations
  },
  datetime: {
    component: _datetime["default"],
    validations: _datetime.validations
  },
  date_of_birth: {
    component: _dob["default"],
    validations: _dob.validations
  },
  email_confirm: {
    field: _emailConfirm["default"]
  },
  english: {
    component: _english["default"],
    answers: retrieveAnswers(_english.answerValues)
  },
  error_summary: {
    field: _error_summary["default"]
  },
  language: {
    component: _language_intl["default"],
    answers: retrieveAnswers(_language_intl.answerValues)
  },
  ethnicity: {
    component: _ethnicity["default"],
    answers: retrieveAnswers(_ethnicity.answerValues)
  },
  ess: {
    component: _ESS["default"],
    validations: _ESS.validations
  },
  field_container: {
    component: _fieldContainer["default"]
  },
  file_uploader: {
    component: _fileUpload["default"],
    validations: _fileUpload.validations
  },
  gad7: {
    component: _GAD["default"],
    validations: _GAD.validations
  },
  gender: {
    component: _gender["default"],
    answers: retrieveAnswers(_gender.answerValues)
  },
  mask_custom: {
    component: _maskCustom["default"],
    validations: _maskCustom.validations
  },
  number: {
    component: _number.NumberInput,
    validations: _number.validations
  },
  phq9: {
    component: _PHQ["default"],
    validations: _PHQ.validations
  },
  pregnancy: {
    component: _pregnancy["default"],
    answers: retrieveAnswers(_pregnancy.answerValues)
  },
  radioinput: {
    component: _radio["default"]
  },
  radio2: {
    component: _radio2["default"]
  },
  range_horizontal: {
    component: _rangeHorizontal["default"],
    validations: _validations2.validations
  },
  range_slider: {
    component: _rangeSlider["default"],
    validations: _validations2.validations
  },
  'select-number-range': {
    field: _selectNumberRange["default"]
  },
  'time (24-hour clock)': {
    component: _time["default"]
  },
  pin: {
    component: _pin["default"],
    validations: _pin.validations
  },
  selectadvanced: {
    component: _selectAdvanced["default"]
  },
  sex: {
    component: _sex["default"],
    answers: retrieveAnswers(_sex.answerValues)
  },
  simple_matrix: {
    component: _simpleMatrix["default"],
    validations: _simpleMatrix.validations
  },
  us_resident: {
    component: _usResident["default"],
    answers: retrieveAnswers(_usResident.answerValues)
  },
  country_resident: {
    component: _country_resident["default"],
    answers: retrieveAnswers(_country_resident.answerValues)
  },
  typing_test: {
    component: _typingTest["default"]
  },
  textarea_file: {
    component: _textAreaFile["default"],
    validations: _textAreaFile.validations
  },
  code_area: {
    component: _codeArea["default"]
    // validations: textarea_file_validations,
  },
  height_intl: {
    component: _heightIntl["default"],
    validations: _heightIntl.validations
  },
  weight_intl: {
    component: _weightIntl["default"],
    validations: _weightIntl.validations
  },
  phone_intl: {
    component: _phonenumberIntl["default"]
  },
  passwordmodern: {
    component: _passwordModern["default"],
    validations: _passwordModern.validations
  }
};